import { z } from "zod";
import { GOLDEN_ASSET_KIND_VALUES, GOLDEN_ASSET_OWNER_TYPE_VALUES, GOLDEN_ASSET_STATUS_VALUES } from "../../constants/golden-asset.js";
export const goldenAssetsQuerySchema = z.object({
    kind: z.enum(GOLDEN_ASSET_KIND_VALUES).optional(),
    ownerType: z.enum(GOLDEN_ASSET_OWNER_TYPE_VALUES).optional(),
    ownerId: z.uuid().optional(),
    status: z.enum(GOLDEN_ASSET_STATUS_VALUES).optional(),
});
export const AdminGoldenAssetSchema = z.object({
    id: z.uuid(),
    seriesId: z.uuid(),
    kind: z.enum(GOLDEN_ASSET_KIND_VALUES),
    ownerType: z.enum(GOLDEN_ASSET_OWNER_TYPE_VALUES),
    ownerId: z.uuid().nullable(),
    imageUrl: z.url(),
    version: z.number().int().positive(),
    status: z.enum(GOLDEN_ASSET_STATUS_VALUES),
    prompt: z.string().nullable(),
    seed: z.number().int().nullable(),
    sourceJobId: z.uuid().nullable(),
    createdAt: z.string(),
});
export const AdminGoldenAssetListSchema = z.object({
    assets: z.array(AdminGoldenAssetSchema),
});
